module.exports = __webpack_public_path__ + "img/icon_header_logout_w.915aa2dd.svg";